import React, {useState} from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import {Link, useNavigate} from 'react-router-dom';
import {useFormik} from 'formik';
import {requestPassword,resetPassword} from '../core/_requests';
import { toast } from 'react-toastify';
import {useIntl} from 'react-intl';

const initialValues = {
  email: '',
};
const initialValues2 = {
  code: '',
  newPassword: '',
  confirmPassword: '',
};

// const regularExpressionPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,18}$/;

// const forgotPasswordSchema = Yup.object().shape({
//   email: Yup.string()
//     .email('Không đúng định dạng email')
//     .min(3, 'Email lớn hơn 3 ký tự')
//     .max(50, 'Email nhỏ hơn 50 ký tự')
//     .required('Email bắt buộc'),
// });
// const forgotPasswordSchema2 = Yup.object().shape({
//   code: Yup.string()
//     .min(6, 'bắt buộc 6 số')
//     .max(6, 'bắt buộc 6 số')
//     .required('Vui lòng nhập mã gửi về trong email'),
//   newPassword: Yup.string()
//     .matches(
//       regularExpressionPassword,
//       'Mật khẩu từ 6-18 ký tự, phải có: chữ hoa, chữ thường và các ký tự đặc biệt!'
//     )
//     .min(6, 'Mật khẩu tối thiểu 6 ký tự!')
//     .max(18, 'Mật khẩu tối đa 18 ký tự!')
//     .required('Không hợp lệ!'),
//   confirmPassword: Yup.string()
//     .required('Không hợp lệ!')
//     .when('newPassword', {
//       is: (val: any) => (val && val.length > 0 ? true : false),
//       then: Yup.string().oneOf([Yup.ref('newPassword')], 'Mật khẩu không khớp!'),
//     }),
// });

export function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined);
  const [statusChange, setStatusChange] = useState<boolean | true>(true); //true là nhập email, false là nhập otp
  const [statusErr,setStatusErr] = useState<string | "">("")
  const [email,setEmail] = useState<string | "">("")
  const intl = useIntl();

  const regularExpressionPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,18}$/;

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA.EMAIL.INVALIDFORMAT'}))
    .min(3, intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA.EMAIL.TOOSHORT'}))
    .max(50, intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA.EMAIL.TOOLONG'}))
    .required(intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA.EMAIL.REQUIRED'})),
  });
  const forgotPasswordSchema2 = Yup.object().shape({
    code: Yup.string()
      .min(6, intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA2.CODE.TOOSHORT'}))
      .max(6, intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA2.CODE.TOOLONG'}))
      .required(intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA2.CODE.REQUIRED'})),
    newPassword: Yup.string()
      .matches(
        regularExpressionPassword,
        intl.formatMessage({id: 'FORGOTPASSWORDSCHEMA2.NEWPASSWORD.PATTERN'})
      )
      .min(6, {id: 'FORGOTPASSWORDSCHEMA2.NEWPASSWORD.TOOSHORT'})
      .max(18, {id: 'FORGOTPASSWORDSCHEMA2.NEWPASSWORD.TOOLONG'})
      .required({id: 'FORGOTPASSWORDSCHEMA2.NEWPASSWORD.REQUIRED'}),
    confirmPassword: Yup.string()
      .required({id: 'FORGOTPASSWORDSCHEMA2.CONFIRMPASSWORD.REQUIRED'})
      .when('newPassword', {
        is: (val: any) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref('newPassword')], {id: 'FORGOTPASSWORDSCHEMA2.CONFIRMPASSWORD.NOMATCH'}),
      }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      if (statusChange) {
        setLoading(true);
        setHasErrors(undefined);
        setTimeout(() => {
          requestPassword(values.email)
            .then((data: any) => {
              if (data == 200) {
                setEmail(values.email);
                setHasErrors(false);
                setLoading(false);
                setStatusChange(false);
              } else {
                setHasErrors(true);
                setLoading(false);
                setSubmitting(false);
                setStatusErr(intl.formatMessage({id: 'FORGOTPASSWORD.EMAILREVIEW'}));
              }
            })
            .catch(() => {
              setHasErrors(true);
              setLoading(false);
              setSubmitting(false);
              setStatusErr(intl.formatMessage({id: 'FORGOTPASSWORD.EMAILREVIEW'}));
            });
        }, 1000);
      }
    },
  });
  const formik2 = useFormik({
    initialValues: initialValues2,
    validationSchema: forgotPasswordSchema2,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      if (!statusChange) {
        setLoading(true);
resetPassword(values.code,values.newPassword,email)
.then((response)=>{
  if(response?.status ==200){
    toast.success(intl.formatMessage({id: 'LOG.UPDATESUCESSFUL'}),{ autoClose:false})
    setLoading(false);
    setHasErrors(false);
    navigate("/auth/login")

  }
})



      }
    },
  });

  return (
    <>
      {statusChange ? (
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_password_reset_form'
          onSubmit={formik.handleSubmit}
        >
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark mb-3'>{intl.formatMessage({id: 'FORGOTPASSWORD.FORGOTPASSWORD'})}</h1>
            {/* end::Title */}

            {/* begin::Link */}
            {/* <div className='text-gray-400 fw-bold fs-4'>Vui lòng nhập email đăng ký tài khoản</div> */}
            {/* end::Link */}
          </div>

          {/* begin::Title */}
          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{statusErr}</div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info rounded'>
              <div className='text-info'>{intl.formatMessage({id: 'FORGOTPASSWORD.EMAIL.CKECKEMAIL'})}</div>
            </div>
          )}
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({id: 'FORGOTPASSWORD.EMAIL'})}</label>
            <input
              type='email'
              placeholder={intl.formatMessage({id: 'FORGOTPASSWORD.EMAIL'})}
              autoComplete='off'
              {...formik.getFieldProps('email')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.email && formik.errors.email},
                {
                  'is-valid': formik.touched.email && !formik.errors.email,
                }
              )}
            />
            {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.email}</span>
                </div>
              </div>
            )}
          </div>
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='btn btn-lg btn-primary fw-bolder me-4'
            >
              <span className='indicator-label'>{intl.formatMessage({id: 'FORGOTPASSWORD.GETOTP'})}</span>
              {loading && (
                <span className='indicator-progress'>
                  {intl.formatMessage({id: 'FORGOTPASSWORD.PLSWAIT'})}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-lg btn-light-primary fw-bolder'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                  {intl.formatMessage({id: 'BTN.CANCEL'})}
              </button>
            </Link>{' '}
          </div>
          {/* end::Form group */}
        </form>
      ) : (
        <>
          <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik2.handleSubmit}
          >
            <div className='text-center mb-10'>
              {/* begin::Title */}
              <h1 className='text-dark mb-3'>{intl.formatMessage({id: 'FORGOTPASSWORD.FORGOTPASSWORD'})}</h1>
              {/* end::Title */}

              {/* begin::Link */}
              {/* <div className='text-gray-400 fw-bold fs-4'>Vui lòng nhập email đăng ký tài khoản</div> */}
              {/* end::Link */}
            </div>

            {/* begin::Title */}
            {hasErrors === true && (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{intl.formatMessage({id: 'FORGOTPASSWORD.ERROR'})}</div>
              </div>
            )}

            {hasErrors === false && (
              <div className='mb-10 bg-light-info rounded'>
                <div className='text-info'>{intl.formatMessage({id: 'FORGOTPASSWORD.EMAIL.CKECKEMAIL'})}</div>
              </div>
            )}
            {/* end::Title */}

            {/* begin::Form group */}
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({id: 'FORGOTPASSWORD.OTP'})}</label>
              <input
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik2.touched.code && formik2.errors.code},
                  {
                    'is-valid': formik2.touched.code && !formik2.errors.code,
                  }
                )}
                type='text'
                {...formik2.getFieldProps('code')}
                placeholder={intl.formatMessage({id: 'FORGOTPASSWORD.EMAIL.CKECKCODE'})}
                autoComplete='off'
              />
              {formik2.touched.code && formik2.errors.code && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik2.errors.code}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({id: 'FORGOTPASSWORD.NEWPASS'})}</label>
              <input
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik2.touched.newPassword && formik2.errors.newPassword},
                  {
                    'is-valid': formik2.touched.newPassword && !formik2.errors.newPassword,
                  }
                )}
                type='password'
                placeholder={intl.formatMessage({id: 'FORGOTPASSWORD.NEWPASS'})}
                autoComplete='off'
                {...formik2.getFieldProps('newPassword')}
              />
              {formik2.touched.newPassword && formik2.errors.newPassword && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik2.errors.newPassword}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>
                {intl.formatMessage({id: 'FORGOTPASSWORD.REPEATNEWPASS'})}
              </label>
              <input
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik2.touched.confirmPassword && formik2.errors.confirmPassword},
                  {
                    'is-valid': formik2.touched.confirmPassword && !formik2.errors.confirmPassword,
                  }
                )}
                type='password'
                placeholder={intl.formatMessage({id: 'FORGOTPASSWORD.REPEATNEWPASS'})}
                autoComplete='off'
                {...formik2.getFieldProps('confirmPassword')}
              />
              {formik2.touched.confirmPassword && formik2.errors.confirmPassword && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik2.errors.confirmPassword}</span>
                  </div>
                </div>
              )}
            </div>

            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-lg btn-primary fw-bolder me-4'
              >
                <span className='indicator-label'>{intl.formatMessage({id: 'FORGOTPASSWORD.BTNSUCCESS'})}</span>
                {loading && (
                  <span className='indicator-progress'>
                    {intl.formatMessage({id: 'FORGOTPASSWORD.PLSWAIT'})}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <Link to='/auth/login'>
                <button
                  type='button'
                  id='kt_login_password_reset_form_cancel_button'
                  className='btn btn-lg btn-light-primary fw-bolder'
                  disabled={formik2.isSubmitting || !formik2.isValid}
                >
                  {intl.formatMessage({id: 'BTN.CANCEL'})}
                </button>
              </Link>{' '}
            </div>
            {/* end::Form group */}
          </form>
        </>
      )}
    </>
  );
}
